import { createContext, Dispatch, SetStateAction } from 'react';

interface SignInContextProps {
    useVerified: [boolean, Dispatch<SetStateAction<boolean>>];
    useValue: [string, Dispatch<SetStateAction<string>>]
    useInputValue: [string, Dispatch<SetStateAction<string>>];
    useInputAuthCode: [string, Dispatch<SetStateAction<string>>];
}

const SignInContext = createContext<SignInContextProps>({} as SignInContextProps);

export default SignInContext;
